export const LEASE_STATUS_TYPES = {
  CURRENT: 'Current',
  NOTICE: 'Notice',
  FUTURE: 'Future',
  APPLICANT: 'Applicant',
  PAST: 'Past',
  CANCELLED: 'Cancelled',
}

export const LOGIN_ACTIONS = [
  'login',
  'getPropertyAssociations',
  'resetPassword',
  'validateResetPasswordCode',
  'updatePassword',
  'getEnrollSettings',
  'enroll',
  'redirectDedupeCustomer',
  'createPassword',
]
